import $ from "jquery";
// eslint-disable-next-line import/no-extraneous-dependencies, import/extensions
import '../../../node_modules/@accessible360/accessible-slick/slick/slick.js';
import Drupal from 'drupal';
import Once from '../../../node_modules/@drupal/once/src/once';

// Add jQuery.type polyfill for jQuery 4 compatibility with Slick
interface JQueryStatic {
  type?: (obj: any) => string;
}

if (typeof $.type !== 'function') {
  ($ as JQueryStatic).type = function(obj: any): string {
    if (obj == null) {
      return String(obj);
    }
    return typeof obj === "object" || typeof obj === "function" ?
      Object.prototype.toString.call(obj).slice(8, -1).toLowerCase() || "object" :
      typeof obj;
  };
}

Drupal.behaviors.splitViewTabs = {
  attach(context) {
    Once('splitViewTabsAttach', '.c-split-view-tabs', context).forEach((el: HTMLElement) => {
      const $el = $(el);
      const desktopMediaQuery = window.matchMedia('(min-width: 64em)');

      function getTabTitles() {
        const tabElements = el.querySelectorAll('[data-title]');
        const tabTitles: string[] = [];
        tabElements.forEach((element) => {
          const dataValue = element.getAttribute('data-title');
          if (dataValue != null) {
            tabTitles.push(dataValue);
          }
        });
        return tabTitles;
      }

      function getActiveTabIndex() {
        const listItems = el.querySelectorAll('.slick-dots li');
        const activeListItem = el.querySelector('.slick-dots li.slick-active');
        if (!activeListItem) return 0;
        return Array.from(listItems).indexOf(activeListItem);
      }

      function getControlsScroll() {
        return el.querySelector('.c-split-view-tabs__controls-scroll');
      }

      function wrapControlsScroll() {
        const controls = el.querySelector('.c-split-view-tabs__controls');
        const slickDots = controls?.querySelector('.slick-dots');
        if (!controls || !slickDots || controls.querySelector('.c-split-view-tabs__controls-scroll')) {
          return;
        }

        const scrollWrap = document.createElement('div');
        scrollWrap.classList.add('c-split-view-tabs__controls-scroll');
        // Make the horizontally scrollable tab list keyboard-focusable.
        scrollWrap.setAttribute('tabindex', '0');
        scrollWrap.setAttribute('role', 'region');
        scrollWrap.setAttribute('aria-label', Drupal.t('Tab navigation'));
        controls.insertBefore(scrollWrap, slickDots);
        scrollWrap.appendChild(slickDots);
        scrollWrap.addEventListener('scroll', positionTabLabel);
      }

      function scrollActiveTabIntoView() {
        if (!desktopMediaQuery.matches) return;

        const scrollWrap = getControlsScroll();
        const activeListItem = el.querySelector('.slick-dots li.slick-active');
        if (!scrollWrap || !activeListItem) return;

        const scrollRect = scrollWrap.getBoundingClientRect();
        const targetRect = activeListItem.getBoundingClientRect();
        const edgeOffset = 8;

        if (targetRect.left < scrollRect.left + edgeOffset) {
          scrollWrap.scrollLeft -= scrollRect.left - targetRect.left + edgeOffset;
        }
        else if (targetRect.right > scrollRect.right - edgeOffset) {
          scrollWrap.scrollLeft += targetRect.right - scrollRect.right + edgeOffset;
        }
      }

      function positionTabLabel() {
        if (!desktopMediaQuery.matches) return;

        const controls = el.querySelector('.c-split-view-tabs__controls');
        const activeListItem = el.querySelector('.slick-dots li.slick-active');
        const label = el.querySelector('.c-split-view-tabs__label') as HTMLElement | null;
        if (!controls || !activeListItem || !label) return;

        const controlsRect = controls.getBoundingClientRect();
        const itemRect = activeListItem.getBoundingClientRect();
        label.style.marginLeft = `${itemRect.left - controlsRect.left}px`;
      }

      function updateNextButton(tabTitles: string[], activeIndex: number) {
        const nextButton = el.querySelector('.c-split-view-tabs__next-tab');
        const nextButtonSpan = el.querySelector('.c-split-view-tabs__next-tab span');
        if (nextButton != null && nextButtonSpan != null) {
          nextButton.classList.toggle('hidden', tabTitles[activeIndex + 1] === undefined);
          nextButtonSpan.textContent = tabTitles[activeIndex + 1] || '';
        }
      }

      function updateRestartButton(activeIndex: number) {
        const restartButton = el.querySelector('.c-split-view-tabs__restart');
        const slides = el.querySelectorAll('.c-split-view-tabs .slick-dots li');
      
        if (restartButton != null) {
          restartButton.classList.toggle('hidden', activeIndex !== slides.length - 1);
        }
      }

      function updateTabLabel(tabTitles: string[], activeIndex: number) {
        const controls = el.querySelector('.c-split-view-tabs__controls');
        if (!controls) return;
        el.querySelector('.c-split-view-tabs__label')?.remove();
        const span = document.createElement('span');
        span.classList.add('c-split-view-tabs__label');
        span.textContent = tabTitles[activeIndex] || '';
        controls.append(span);
        requestAnimationFrame(() => {
          scrollActiveTabIntoView();
          positionTabLabel();
        });
      }

      function removeTabLabel() {
        const label = el.querySelector('.c-split-view-tabs__label') as HTMLElement | null;
        if (label) {
          label.remove();
        }
      }

      function updateLabelState() {
        const tabTitles = getTabTitles();
        const activeIndex = getActiveTabIndex();
        updateNextButton(tabTitles, activeIndex);
        updateRestartButton(activeIndex);
        if (desktopMediaQuery.matches) {
          updateTabLabel(tabTitles, activeIndex);
        }
        else {
          removeTabLabel();
        }
      }

      const handleResize = () => {
        updateLabelState();
      };

      window.addEventListener('resize', handleResize);

      $el.find('.c-split-view-tabs__images').on('beforeChange', () => {
        removeTabLabel();
      });

      $el.find('.c-split-view-tabs__images').on('afterChange init', () => {
        updateLabelState();
      });

      $el.find('.c-split-view-tabs__next-tab').on('click', () => {
        ($el.find('.c-split-view-tabs__images') as any).slick('slickNext');
      });

      $el.find('.c-split-view-tabs__restart').on('click', () => {
        ($el.find('.c-split-view-tabs__images') as any).slick('slickGoTo', 0);
      });

      ($el.find('.c-split-view-tabs__images') as any).slick({
        asNavFor: '.c-split-view-tabs__text, .c-split-view-tabs__text-images',
        autoplay: false,
        width: '100%',
        appendDots: $el.find('.c-split-view-tabs__controls'),
        fade: true,
        dots: true,
        infinite: false,
        arrows: false,
        customPaging: function (_slider: unknown, i: number) {
          return `<button type="button"><span class="usa-sr-only">Go to slide </span>${i + 1}</button>`;
        }
      });

      wrapControlsScroll();

      ($el.find('.c-split-view-tabs__text-images') as any).slick({
        autoplay: false,
        width: '100%',
        fade: true,
        dots: false,
        infinite: false,
        arrows: false,
        adaptiveHeight: true
      });

      ($el.find('.c-split-view-tabs__text') as any).slick({
        autoplay: false,
        width: '100%',
        fade: true,
        dots: false,
        infinite: false,
        arrows: false,
        adaptiveHeight: true
      });
    });
  }
};
